class SubcollectionsSwiper extends HTMLElement {
  constructor(){
    super();
    this.swiperElement = this.querySelector('.collection__subcollection.swiper');
    this.swiperOptions = {
      slidesPerView: 3.5,
      spaceBetween: 10,
      breakpoints: {
        1024: {
          slidesPerView: "auto",
          spaceBetween: 16,
        },
      },
    };
  }
 
  connectedCallback() {
    this.swiperInit();
  }

  disconnectedCallback() {
  }

  swiperInit() {
    if (this.swiperElement) {
      this.swiper = new Swiper(this.swiperElement, this.swiperOptions);
    }
  }
}

if (!window.customElements.get("subcollections-swiper")) {
  window.customElements.define("subcollections-swiper", SubcollectionsSwiper );
}